<template>
  <b-form :class="[{ 'pe-none': is_selesai }]">
    <span style="font-weight: 600">{{ formTitle }}</span>
    <div class="mt-3">
      <label>
        Kemajuan dalam memperoleh persetujuan lingkungan, Perizinan Berusaha
        dan/atau persetujuan non berusaha
      </label>
      <div style="width: 300px">
        <v-select
          v-model="form.kemajuan"
          id="a_persetujuan_lingkungan"
          :reduce="(data) => data.value"
          label="text"
          :options="optionKewajiban"
          name="Persetujuan Lingkungan"
          v-validate="'required'"
        />
      </div>
      <span class="text-danger" v-if="errors.has('Kemajuan Persetujuan')">
        {{ errors.first('Kemajuan Persetujuan') }}
      </span>
    </div>
    <div class="mt-3">
      <label>
        Realisasi luas perairan dan pemanfaatannya dalam hal Perizinan Berusaha
        dan/atau perizinan non berusaha telah diterbitkan
      </label>
      <div style="width: 300px">
        <v-select
          v-model="form.realisasi"
          id="a_persetujuan_lingkungan"
          :reduce="(data) => data.value"
          label="text"
          :options="optionKewajiban"
          name="Persetujuan Lingkungan"
          v-validate="'required'"
        />
      </div>
      <span class="text-danger" v-if="errors.has('Realisasi')">
        {{ errors.first('Realisasi') }}
      </span>
    </div>
    <div class="mt-3">
      <label>
        Komitmen penyampaian laporan tahunan KKPRL setiap tahun sebelum jatuh
        tempo
      </label>
      <div style="width: 300px">
        <v-select
          v-model="form.komitmen"
          id="a_persetujuan_lingkungan"
          :reduce="(data) => data.value"
          label="text"
          :options="optionKewajiban"
          name="Persetujuan Lingkungan"
          v-validate="'required'"
        />
      </div>
      <span
        class="text-danger"
        v-if="errors.has('Komitmen Penyampaian Laporan')"
      >
        {{ errors.first('Komitmen Penyampaian Laporan') }}
      </span>
    </div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  components: {
    vSelect,
  },
  props: ['formTitle', 'page'],
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      form: {
        kemajuan: 'Sudah',
        realisasi: 'Sudah',
        komitmen: 'Sudah',
      },
      is_selesai: false,
      optionKewajiban: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum', text: 'Belum' },
      ],
    }
  },
  mounted() {
    this.loadLaporanTahunan()
  },
  methods: {
    async nextForm() {
      if (this.is_selesai) {
        return true
      }

      if (await this.$validator.validateAll()) {
        this.$loading(true)
        const formData = new FormData()
        // prettier-ignore
        {
          formData.append('kemajuan_persetujuan_lingkungan_13', this.form.kemajuan)
          formData.append('realisasi_luas_perairan_13', this.form.realisasi)
          formData.append('komitmen_penyampaian_laporan_tahunan_13', this.form.komitmen)
        }

        return axios
          .post(
            this.baseapi +
              `api/laporan_tahunan/${this.$route.query.id_laporan}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((res) => {
            return true
          })
          .catch((err) => {
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        return false
      }
    },

    loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      axios
        .get(
          `${this.baseapi}api/laporan_tahunan/${this.$route.query.id_laporan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          const data = res.data.data
          this.is_selesai =
            data.status_laporan !== null &&
            data.status_laporan !== 'Draft' &&
            data.status_laporan !==
              'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
          this.form = {
            kemajuan: data.kemajuan_persetujuan_lingkungan_13 || 'Sudah',
            realisasi: data.realisasi_luas_perairan_13 || 'Sudah',
            komitmen: data.komitmen_penyampaian_laporan_tahunan_13 || 'Sudah',
          }
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },
  },
}
</script>
